module.exports = __webpack_public_path__ + "static/media/puzzleImage.5949e060.png";